var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8129 5.62402H3.26968C2.56977 5.62402 2 6.2056 2 6.92002V14.696C2 15.4104 2.56977 15.992 3.26968 15.992H16.8129C17.5128 15.992 18.0826 15.4104 18.0826 14.696V6.92002C18.0826 6.2056 17.5128 5.62402 16.8129 5.62402ZM16.8129 6.48802C16.8383 6.48802 16.8621 6.49072 16.8864 6.49504L10.5111 10.8334C10.2656 11.0003 9.81804 11.0003 9.57257 10.8334L3.1972 6.49504C3.22101 6.49072 3.24534 6.48802 3.27074 6.48802H16.814H16.8129ZM16.8129 15.128H3.26968C3.03585 15.128 2.84645 14.9347 2.84645 14.696V7.29478L9.10279 11.5516C9.36625 11.7303 9.70377 11.8205 10.0413 11.8205C10.3788 11.8205 10.7169 11.7309 10.9798 11.5516L17.2361 7.29478V14.696C17.2361 14.9347 17.0467 15.128 16.8129 15.128Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.8c4dd147998e7dc14140396ac34d02a6.svg";
export { ForwardRef as ReactComponent };